import * as yup from 'yup'

const PettyCashAccountsSchem = yup.object().shape({
    userId: yup.string().required('This field is required.'),
    pettyCashAccount: yup.string().required('This field is required.'),
    pettyCashUsersIds: yup.array().of(yup.string()).min(1, 'Please select at least one account user.')
})

export { PettyCashAccountsSchem  };